/**
 * @file 插入菜单和更多工具共用的方法，主要是插入容器、插入地图
 * @author luokq
 */

import { Vue, Component } from "vue-property-decorator";
import appConfig from "@/public/globalConfig";
declare var EDDocument: any;
declare var echarts: any;

@Component
export default class InsertDropsMixins extends Vue {
    libraryWorkerURL: string = appConfig.libraryWorkerURL;

    get chartLoadedStatus() {
        return this.$store.state.ui.chartLoadedStatus;
    }
    set chartLoadedStatus(v) {
        this.$store.commit("setStatus", {
            type: "chartLoadedStatus",
            data: v,
        });
    }

    setProcess(num) {
        this.$store.commit("setStatus", {
            type: "LoadingProcess",
            data: num > 1 ? 1 : num < 0 ? 0 : num,
        });
    }

    toggleLoading(type, textStr = "map") {
        if (type) {
            this.setProcess(0);
            this.$store.commit("setStatus", {
                type: "loadingTextType",
                data: textStr,
            });
        }
        this.$store.commit("setStatus", {
            type: "Loading",
            data: type,
        });
    }

    showDialog(target) {
        this.$store.commit("setDialogState", {
            type: "dialogType",
            data: target,
        });
        this.$store.commit("setDialogState", {
            type: "showDialog",
            data: true,
        });
    }

    showMapHandler() {
        let loadingEnd = () => {
            // 加载完成后打开弹窗
            // 地图注册
            EDDocument.getEChartsData().then((e) => {
                let MapData = EDDocument._eChartData;
                for (let i in MapData) {
                    for (let key in MapData[i]) {
                        echarts.registerMap(key, MapData[i][key]);
                    }
                }
                this.toggleLoading(false);
                this.showDialog("InsertMap");
            });
        };
        if (!this.chartLoadedStatus) {
            this.toggleLoading(true);
            this.chartLoadedStatus = 1;
            this.$store.dispatch("loadConfig", ["EChartsData.tar"]).then((e) => {
                this.chartLoadedStatus = 2;
                this.setProcess(1);
                loadingEnd();
            });
        } else if (this.chartLoadedStatus == 2) {
            loadingEnd();
        }
    }

    insertContainerHandler() {
        const CONTAINER_GROUPID = 11,
            CONTAINER_TABLEID = 1;
        let menu = this.$store.state.library.menuList,
            DBName = "",
            TBName = "",
            versionObj = null,
            url = "";
        for (let i = 0; i < menu.length; i++) {
            if (menu[i].id == CONTAINER_GROUPID) {
                DBName = menu[i].groupName;
                let tables = menu[i].children;
                for (let j = 0; j < tables.length; j++) {
                    if (tables[j].id == CONTAINER_TABLEID) {
                        TBName = tables[j].tableName;
                        versionObj = {
                            tableID: CONTAINER_TABLEID,
                            name: TBName,
                            version: tables[j].version,
                            type: tables[j].type,
                            group: DBName,
                            mcount: tables[j].mcount,
                        };
                        url = tables[j].url;
                        break;
                    }
                }
            }
        }
        let checkDBVersion = (versionObj) => {
            // 检查符号库的版本
            return new Promise((res, rej) => {
                let opendb = self.indexedDB.open("versionDB");
                opendb.onsuccess = (e) => {
                    // 检查是否下载库
                    let db = opendb.result;
                    let trans = db.transaction("version", "readwrite");
                    let objstore = trans.objectStore("version");

                    var index = objstore.index("tableIDIndex");
                    index.get(versionObj.tableID).onsuccess = (e) => {
                        let data = (e.target as IDBRequest).result;
                        if (data) {
                            // 有数据且版本不一致 需要更新
                            if (data.version !== versionObj.version || data.group !== versionObj.group) res("update");
                            else rej();
                        } else {
                            res("new");
                        }
                        db.close();
                    };
                };
            });
        };
        let downloadDB = (DBName, tableName, url, versionObj, type) => {
            return new Promise((rs, rj) => {
                let worker = new Worker(this.libraryWorkerURL);
                worker.postMessage({
                    type: type,
                    lang: appConfig.language,
                    urls: this.urls,
                    data: {
                        DBName,
                        tableName,
                        url,
                        versionObj,
                    },
                });
                worker.onmessage = (e) => {
                    let message = e.data;
                    if (message.type === "download error") {
                        this.toggleLoading(false);
                        worker.terminate();
                    }
                    if (message.type === "loaded" || message.type === "data is lastest") {
                        this.toggleLoading(false);
                        worker.terminate();
                        rs();
                    }
                    if (message.type === "process") {
                        this.setProcess(message.process);
                    }
                };
            });
        };
        if (!versionObj) {
            return;
        }
        checkDBVersion(versionObj)
            .then((type) => {
                this.toggleLoading(true, "library");
                downloadDB(DBName, TBName, url, versionObj, type).then((e) => {
                    this.showDialog("InsertContainer");
                });
            })
            .catch((e) => {
                // 不需要更新
                this.showDialog("InsertContainer");
            });
    }
}
